// Module
var code = "<div class=\"c-tieredPricingTooltip\">\n    <div ng-repeat=\"trigger in context track by $index\">\n        <div ng-class=\"{'u-mb+': '!$last'}\" ng-bind=\"trigger.DisplayName || trigger.Name\"></div>\n    </div>\n</div>\n";
// Exports
module.exports = code;